/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export enum TransactionTypeApiModel {
  Reserve = 'reserve',

  Presale = 'presale',

  Sale = 'sale',

  Cancel = 'cancel',

  RedeemGiftcard = 'redeem-giftcard',

  BonusAdd = 'bonus-add',

  SpecialAccountRefill = 'special-account-refill',

  CouponSale = 'coupon-sale',

  AuthorizePayment = 'authorize-payment',

  BonusWriteOffs = 'bonus-write-offs',

  SpecialAccountWriteOffs = 'special-account-write-offs'
}
